import React from 'react';
import { FiInbox, FiBookOpen, FiActivity, FiBell, FiFileText, FiUsers } from 'react-icons/fi';
import './ParentEmptyState.css';

const variants = {
  'no-students': {
    icon: FiUsers,
    title: 'No connected students',
    description: 'Connect a student to begin viewing assignments, activity, and progress.',
    actionLabel: 'Add a Student',
  },
  'no-assignments': {
    icon: FiBookOpen,
    title: 'No assignments available',
    description: 'No assignments are available yet. They will appear once course information has been added.',
    actionLabel: null,
  },
  'no-activity': {
    icon: FiActivity,
    title: 'Not enough activity yet',
    description: 'There is not enough activity to generate a trend yet. Check back after a few days of study.',
    actionLabel: null,
  },
  'no-alerts': {
    icon: FiBell,
    title: 'Everything looks on track',
    description: "We'll let you know when something needs attention. No alerts right now.",
    actionLabel: null,
  },
  'no-reports': {
    icon: FiFileText,
    title: 'No reports available yet',
    description: 'Your first weekly report will appear once enough activity is available.',
    actionLabel: null,
  },
  'no-data': {
    icon: FiInbox,
    title: 'No data available',
    description: 'There is nothing to display here yet.',
    actionLabel: null,
  },
};

function ParentEmptyState({ variant = 'no-data', onAction }) {
  const config = variants[variant] || variants['no-data'];
  const Icon = config.icon;

  return (
    <div className="parent-empty-state" role="status">
      <div className="parent-empty-state__icon">
        <Icon size={32} />
      </div>
      <h3 className="parent-empty-state__title">{config.title}</h3>
      <p className="parent-empty-state__description">{config.description}</p>
      {config.actionLabel && onAction && (
        <button className="parent-empty-state__action" onClick={onAction}>
          {config.actionLabel}
        </button>
      )}
    </div>
  );
}

export default ParentEmptyState;
